var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ais-stats',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var nbHits = ref.nbHits;
var query = ref.query;
return [_c('h2',{staticClass:"pb-4 text-xl font-bold border-b border-blue-100 md:text-3xl md:font-normal"},[_c('span',{staticClass:"text-blue-500 md:font-bold"},[_vm._v(_vm._s(nbHits)+" Results")]),_vm._v(" "),(query)?_c('span',{staticClass:"text-grey-500 md:sr-only"},[_vm._v("For '"+_vm._s(query)+"'")]):_vm._e()])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }